import { Component } from '@angular/core';

@Component({
  selector: 'cigna-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {}
